import * as r from 'ramda';

export function isShown(state, mapId) {
    return r.pathOr(false, ['map', mapId, 'show'], state);
}
